import { render, staticRenderFns } from "./VBtnMenu.vue?vue&type=template&id=214b119a&"
import script from "./VBtnMenu.vue?vue&type=script&lang=js&"
export * from "./VBtnMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports